var _metadata, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo2021(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "Layer_1",
    width: 1000,
    height: 324.6835,
    viewBox: "0 0 1000 324.68351",
    overflow: "visible",
    enableBackground: "new 0 0 659.055 202.068",
    xmlSpace: "preserve",
    inkscapeVersion: "1.0.2 (e86c870879, 2021-01-15)",
    sodipodiDocname: "Visa_2021.svg",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3739"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("defs", {
    id: "defs3737"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3801"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#20225f",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop3803"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3815",
    offset: 0.2,
    style: {
      stopColor: "#1a1f61",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3813",
    offset: 0.41023257,
    style: {
      stopColor: "#172272",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3811",
    offset: 0.59519672,
    style: {
      stopColor: "#152682",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3809",
    offset: 0.80208331,
    style: {
      stopColor: "#12288e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0e2c9a",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop3805"
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1366,
    "inkscapeWindow-height": 705,
    id: "namedview3735",
    showgrid: "false",
    "fit-margin-left": 0.5,
    "fit-margin-bottom": 0.5,
    "fit-margin-top": 0.5,
    "fit-margin-right": 0.5,
    inkscapeZoom: 0.49497088,
    inkscapeCx: 473.80866,
    inkscapeCy: -26.853447,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "Layer_1",
    "inkscapeDocument-rotation": 0
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid3787",
    empspacing: 5,
    visible: "true",
    enabled: "true",
    snapvisiblegridlinesonly: "true"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1434cb",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "m 651.18503,0.50000002 c -70.93272,0 -134.32163,36.76584998 -134.32163,104.69357998 0,77.90028 112.42264,83.28082 112.42264,122.41576 0,16.47806 -18.88384,31.22851 -51.13668,31.22851 -45.77308,0 -79.98403,-20.61081 -79.98403,-20.61081 l -14.63836,68.54658 c 0,0 39.41037,17.40989 91.73375,17.40989 77.55217,0 138.57651,-38.57104 138.57651,-107.66029 0,-82.3157 -112.89106,-87.53633 -112.89106,-123.86008 0,-12.9082 15.50201,-27.05169 47.66251,-27.05169 36.28682,0 65.89216,14.98968 65.89216,14.98968 l 14.32608,-66.20444 c 0,0 -32.21317,-13.89668998 -77.64189,-13.89668998 z M 2.2175605,5.49657 0.49999253,15.48969 c 0,0 29.84159547,5.46149 56.71878047,16.35593 34.606624,12.4927 37.071853,19.7653 42.900167,42.35367 l 63.51098,244.83152 85.13673,0 131.15974,-313.53424 -84.94155,0 L 210.7069,218.67018 176.3165,37.97422 C 173.1626,17.29371 157.18709,5.49657 137.63219,5.49657 l -135.4146295,0 z m 411.8650095,0 -66.63383,313.53424 80.99895,0 66.39962,-313.53424 -80.76474,0 z m 451.75943,0 c -19.53181,0 -29.88045,10.45695 -37.47421,28.73022 l -118.66834,284.80402 84.94155,0 16.434,-47.46734 103.48348,0 9.99312,47.46734 74.94843,0 -65.3847,-313.53424 -68.27333,0 z m 11.04709,84.70733 25.17799,117.65341 -67.45359,0 42.2756,-117.65341 z",
    id: "path3789",
    "inkscapeConnector-curvature": 0
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo2021);
export default __webpack_public_path__ + "static/media/visa_logo_2021.878a7e58985af36496223b68c891fcfc.svg";
export { ForwardRef as ReactComponent };